import React from 'react';
import { isEmpty } from 'lodash';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ListItem from '@material-ui/core/ListItem';
import Chip from '@material-ui/core/Chip';

import { getIndicatorColor } from '../../common/global';

import styles from './Route.module.scss';
import ACButton from '../../atoms/ACButton';
import { getSuitableDays } from '../../common/routes';

export default class Route extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const route = this.props.route;
    const product = this.props.route.product || {};

    let productCountry = '';
    let productCity = '';
    if (!isEmpty(product)) {
      if (!isEmpty(product.productCities) && product.productCities.length > 0) {
        productCountry = product.productCities[0].country;
        productCity = product.productCities[0].name;
      }
    }
    const location = [productCity, productCountry].filter(Boolean).join(', ');
    // A route carries its own product and, independently, the components it may deliver -
    // both can be set. Component titles come from the snapshot aex stores on the route, so
    // this needs no lookup per row. A component route takes its location from the occasion
    // rather than carrying one, which is why location can be blank here.
    const componentNames = (route.components || []).map((c) => c && (c.title || c.id));
    const connectionName = [product.name, ...componentNames].filter(Boolean).join(' + ');

    let { itemsDietaries, status = '', providersWhens } = route;

    if (isEmpty(itemsDietaries)) {
      itemsDietaries = {};
    }
    if (isEmpty(providersWhens)) {
      providersWhens = [];
    }

    let borderLeftStyle = `3px solid ${getIndicatorColor(status)}`;
    const isDisabled = isEmpty(route?.stops);   //Considering route as disabled for adding in a booking, when there are no any stops associated with it

    return (
      <ListItem
        disabled={ isDisabled }
        className={styles.root}
        style={{ borderLeft: borderLeftStyle, cursor: isDisabled ? 'default' : 'pointer' }}
        onClick={() => isDisabled ? '' : this.props.onSelectRouteFunc(route)}
      >
        <div className={styles.route}>
          <div>
            <span className={styles.boldFont}>{route.name}</span>
            <br />
            {location}
            <br />
            {connectionName}

            <br />
            <hr />

            <div className={styles.days}>{this.renderWhens(providersWhens)}</div>

            <br />
            <hr />
            {itemsDietaries.vegan && (
              <Chip
                style={{ margin: '0px 2px', color: 'white' }}
                color="secondary"
                label="Vegan"
                size="small"
              />
            )}
            {itemsDietaries.vegetarian && (
              <Chip
                style={{ margin: '0px 2px', color: 'white' }}
                color="secondary"
                label="Vegetarian"
                size="small"
              />
            )}

            {itemsDietaries.glutenFree && (
              <Chip
                style={{ margin: '0px 2px', color: 'white' }}
                color="secondary"
                label="Gluten Free"
                size="small"
              />
            )}
          </div>
          <div>
            <AddCircleOutlineIcon />
          </div>
        </div>
      </ListItem>
    );
  }

  renderWhens(providerWhens) {
    let daysUI = getSuitableDays(providerWhens) || [];
    return daysUI.map((d) => {
      let backgroundColor = '';
      let color = '';

      if (d.value === true) {
        backgroundColor = '#52A8EF';
        color = 'white';
      } else {
        backgroundColor = 'white';
        color = 'black';
      }
      return (
        <ACButton
          text={d.alias}
          backgroundColor={backgroundColor}
          color={color}
          fontSize="10px"
          padding="1px 5px"
          className={styles.capitalized}
          key={d.alias}
        />
      );
    });
  }

}
